import coffeeSrc from "../../../assets/beverageV5/Coffee.svg";
import teaSrc from "../../../assets/beverageV5/Tea.svg";
import juicesSrc from "../../../assets/beverageV5/Juiice.svg";
import milkSrc from "../../../assets/beverageV5/Milk.svg";
import waterSrc from "../../../assets/beverageV5/Water.svg";
import sodaSrc from "../../../assets/beverageV5/Soda.svg";
import energySrc from "../../../assets/beverageV5/EnergyDrink.svg";
import beerSrc from "../../../assets/beverageV5/Beer.svg";
import wineSrc from "../../../assets/beverageV5/Wine.svg";
import spiritsSrc from "../../../assets/beverageV5/Spirits.svg";

import coffeeSrcActive from "../../../assets/beverageV5/CoffeeActive.svg";
import teaSrcActive from "../../../assets/beverageV5/TeaActive.svg";
import juicesSrcActive from "../../../assets/beverageV5/JuiiceActive.svg";
import milkSrcActive from "../../../assets/beverageV5/MilkActive.svg";
import waterSrcActive from "../../../assets/beverageV5/WaterActive.svg";
import sodaSrcActive from "../../../assets/beverageV5/SodaActive.svg";
import energySrcActive from "../../../assets/beverageV5/EnergyDrinkActive.svg";
import beerSrcActive from "../../../assets/beverageV5/BeerActive.svg";
import wineSrcActive from "../../../assets/beverageV5/WineActive.svg";
import spiritsSrcActive from "../../../assets/beverageV5/SpiritsActive.svg";

export const beverageCategories = [
  {
    name: "Coffee",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-seoul-coffee-14153?wid=316&fit=constrain",
    icon: coffeeSrc,
    activeIcon: coffeeSrcActive,
  },
  {
    name: "Tea",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/bonvoy_brand_mbv-1073046?wid=316&fit=constrain",
    icon: teaSrc,
    activeIcon: teaSrcActive,
  },
  {
    name: "Juices",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/cy-selsn-the-22-juice-11454?wid=316&fit=constrain",
    icon: juicesSrc,
    activeIcon: juicesSrcActive,
  },
  {
    name: "Milk",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/ar-madca-breakfast-milk-00614?wid=316&fit=constrain",
    icon: milkSrc,
    activeIcon: milkSrcActive,
  },
  {
    name: "Water",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/si-mlesi-bottled-water-23199?wid=316&fit=constrain",
    icon: waterSrc,
    activeIcon: waterSrcActive,
  },
  {
    name: "Soda",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/cy-bwibd-soda-market-32168?wid=316&fit=constrain",
    icon: sodaSrc,
    activeIcon: sodaSrcActive,
  },
  {
    name: "Energy Drink",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-1309892866?wid=316&fit=constrain",
    activeIcon: energySrcActive,
    icon: energySrc,
  },
  {
    name: "Beer",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/chifo-beer-1-20903?wid=316&fit=constrain",
    activeIcon: beerSrcActive,
    icon: beerSrc,
  },
  {
    name: "Wine",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/jw-wasjw-white-wine-14577?wid=316&fit=constrain",
    activeIcon: wineSrcActive,
    icon: wineSrc,
  },
  {
    name: "Spirits",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/br-bodbr-gina-bar-36925?wid=316&fit=constrain",
    activeIcon: spiritsSrcActive,
    icon: spiritsSrc,
  },
];
